// features/workstations/shared/sectioned-tab.js
// ═══════════════════════════════════════════════════════════
// SECTIONED TAB — header + section pills + content slot.
// Generalized from the Findings tab pattern. Used by every
// tab that has internal sections (Knowledge: Feed/KB/Research,
// Findings: Pattern Library/Signal Matrix/Deep Analysis,
// Works: In Progress/Completed/Templates, etc.).
//
// Props:
//   eyebrow      - small uppercase label above title (optional)
//   title        - section title (Cormorant)
//   subtitle     - small italic gray below title (optional)
//   sections     - array of { key, label, badge? }
//   activeKey    - which section is selected
//   onSelect(key)
//   actions      - optional right-aligned node (CTA buttons etc.)
//   children     - the section body (caller renders based on activeKey)
//
// Renders inside .ws-tab-content; caller is responsible for
// providing that wrapper.
// ═══════════════════════════════════════════════════════════

export default function SectionedTab({
  eyebrow,
  title,
  subtitle,
  sections,
  activeKey,
  onSelect,
  actions,
  children,
}) {
  return (
    <>
      <div className="ws-sectioned-header">
        <div className="ws-sectioned-title-block">
          {eyebrow && <div className="ws-sectioned-eyebrow">{eyebrow}</div>}
          {title && <div className="ws-sectioned-title">{title}</div>}
          {subtitle && <div className="ws-sectioned-subtitle">{subtitle}</div>}
        </div>
        <div className="ws-sectioned-right">
          {sections && sections.length > 0 && (
            <div className="ws-sectioned-pills">
              {sections.map((s) => (
                <button
                  key={s.key}
                  type="button"
                  className={`ws-sectioned-pill${activeKey === s.key ? ' active' : ''}`}
                  onClick={() => onSelect?.(s.key)}
                >
                  {s.label}
                  {s.badge != null && <span className="ws-sectioned-pill-badge">{s.badge}</span>}
                </button>
              ))}
            </div>
          )}
          {actions && <div className="ws-sectioned-actions">{actions}</div>}
        </div>
      </div>
      <div className="ws-sectioned-body">
        {children}
      </div>
    </>
  );
}
